import axios from 'axios';

import config from 'Config';
import * as errors from 'Errors/errors';

export function getVideoThumbnailUrl(videoId) {
  const clientId = config.get('youku.clientId');
  if (!clientId) {
    return Promise.reject(new errors.BadRequest('Missing Youku client Id'));
  }
  if (!videoId) {
    return Promise.reject(new errors.BadRequest('Missing Youku video Id'));
  }
  return axios
    .get(`https://api.youku.com/videos/show.json?client_id=${clientId}&video_id=${videoId}`)
    .then(
      response =>
        response.data.bigThumbnail ||
        response.data.thumbnail ||
        new errors.NotFoundError('Youku video not found'),
    )
    .catch(() => null);
}
